export function getElementOffset( el ) {

	// //console.log('el', el);
	if ( typeof el === 'string' ) {
		el = document.querySelector( el );
	}

	var rect       = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop  = window.pageYOffset || document.documentElement.scrollTop;

	return { top : rect.top + scrollTop, left : rect.left + scrollLeft };
}

// https://www.30secondsofcode.org/js/s/element-is-visible-in-viewport/
export function isElementIsVisibleInViewport( el, partiallyVisible = false ) {
	const { top, left, bottom, right } = el.getBoundingClientRect();
	const { innerHeight, innerWidth }  = window;
	return partiallyVisible
		? ( ( top > 0 && top < innerHeight ) ||
			( bottom > 0 && bottom < innerHeight ) ) &&
		( ( left > 0 && left < innerWidth ) || ( right > 0 && right < innerWidth ) )
		: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
}